module.exports = __webpack_public_path__ + "img/earn_feed_super_discount.c37d0018.png";